import { BaseControlValueAccessor } from './base.accessor';
import { FormControl } from '@angular/forms';

export abstract class FormControlValueAccessor<T> extends BaseControlValueAccessor<T> {
  protected control = new FormControl();
  protected validateControl = () => { };

  onModelTouched = () => { };

  override registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  writeValue(value: T): void {
    this.control.setValue(value);
  }

  setDisabledState?(disabled: boolean): void {
    if (disabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.validateControl = fn;
  }
}
